<template>
  <j-modal
    :title="title"
    :width="width"
    :visible="userVisible"
    switchFullscreen
    @ok="handleOk"
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    @cancel="handleCancel"
    :cancelText="language['common.closeButton']">
    <!--<emp-entrance-manager-user-form ref="userForm" @close="" />-->
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="initDataSource">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['user.column.workNo']">
              <a-input  v-model="queryParam.workNo"  allow-clear></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item :label="language['user.column.realname']">
              <a-input  v-model="queryParam.realname"></a-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchDataSource" icon="search">{{language['common.searchButton']}}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{language['common.resetButton']}}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <a-row :gutter="18">
      <a-col :span="15">
        <div type="flex">
          <a-table
            size="middle"
            :scroll="{x:true}"
            bordered
            rowKey="id"
            :columns="columns"
            :dataSource="dataSource"
            :pagination="ipagination"
            :loading="loading"
            :rowSelection="{selectedRowKeys: selectedIds, onChange: onChange,type:'checkbox',onSelect:onSelect
                ,getCheckboxProps: (record) => {
                  return {
                    props: {
                      disabled: record.disableFlag == '1'
                    },
                  }
                },
              }"
            @change="handleTableChange">
          </a-table>
        </div>
      </a-col>
      <a-col :span="9">
        <div>
          <a-table size="middle"
                   :scroll="{y:250}"
                   :columns="selectedColumns"
                   :pagination="false"
                   bordered
                   :data-source="selectedDataSouce" >
            <span slot="action" slot-scope="text, record">
              <a @click="selectedRemove(record)" v-if="record.disableFlag!='1'">{{language['common.delete']}}</a>
            </span>
          </a-table>
        </div>
      </a-col>
    </a-row>

  </j-modal>
</template>

<script>
  import { getAction,putAction,deleteAction,postAction } from '@/api/manage'
    export default {
      name: "CmsColApproverUserModal",
      data () {
        return {
          queryParam:{},
          dataSource:[],
          /* 分页参数 */
          ipagination: {
            current: 1,
            pageSize: 5,
            showTotal: (total, range) => {
              return range[0] + '-' + range[1] + ' '+this.$store.getters.language['common.total'] + total + this.$store.getters.language['common.strip']
            },
            showQuickJumper: true,
            // showSizeChanger: true,
            total: 0
          },
          selectedIds:[],
          selectedRows:[],
          columns:[
            {
              title:this.$store.getters.language['user.column.workNo'],
              align:"center",
              dataIndex: 'workNo',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title:this.$store.getters.language['user.column.realname'],
              align:"center",
              dataIndex: 'realname',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
          ],
          selectedDataSouce:[],
          dataSouceBak:[],
          selectedColumns:[
            {
              title:this.$store.getters.language['user.column.workNo'],
              align:"center",
              dataIndex: 'realname',
              customCell: () => {
                return {
                  style: {
                    'text-align': 'left'
                  },
                };
              },
            },
            {
              title: this.$store.getters.language['common.action'],
              dataIndex: 'action',
              align:"center",
              scopedSlots: { customRender: 'action' }
            }
          ],
          title:this.$store.getters.language['user'],
          width:900,
          userVisible: false,
          disableSubmit: false,
          colId:"",
        }
      },
      computed: {
        language() {
          return this.$store.getters.language
        },
      },
      methods:{
        add () {
          this.userVisible=true
          this.$nextTick(()=>{
            this.$refs.realForm.add();
          })
        },
        edit (list,colId) {
          this.userVisible=true
          this.selectedDataSouce = list;
          this.dataSouceBak = [...list];
          this.colId = colId;
          this.initDataSource();
        },
        handleTableChange(ipagination){
          this.ipagination = ipagination
          this.initDataSource()
        },
        onChange(selectDataIds,selectDataRows){
          this.selectedRows = selectDataRows;
          this.selectedIds = selectDataIds;
          let ids = this.selectedDataSouce.map(item => item.id);
          let bakids = this.dataSouceBak.map(item => item.id);
          let currentids = this.dataSource.map(item => item.id);

          this.selectedRows.forEach(item=>{
            if (ids.indexOf(item.id) === -1) {
              this.selectedDataSouce.push(item);
            }
          });
          let filteredData = this.selectedDataSouce.filter(item => {
            return this.selectedIds.find(id => id === item.id) === undefined;
          });
          filteredData.forEach(record=>{
            if(this.selectedDataSouce.findIndex(item => item.id === record.id)!==-1) {
              if (bakids.indexOf(record.id) === -1) {
                  if(currentids.indexOf(record.id) !== -1){
                    this.selectedDataSouce.splice(this.selectedDataSouce.findIndex(item => item.id === record.id), 1);
                  }
              }
            }
          })


        },
        onSelect(record, selected,selectedRows,nativeEvent){
          if(selected){
            if(this.selectedDataSouce.findIndex(item => item.id === record.id)===-1){
              this.selectedDataSouce.push(record);
            }
          }else{
            if(this.selectedDataSouce.findIndex(item => item.id === record.id)!==-1){
              this.selectedDataSouce.splice(this.selectedDataSouce.findIndex(item => item.id === record.id),1);
            }

          }
        },
        searchDataSource(){
          this.ipagination.current = 1;
          this.initDataSource()
        },
        initDataSource(){
          let param = this.queryParam;
          param.pageNo = this.ipagination.current;
          param.pageSize = this.ipagination.pageSize;
          param.entranceCode = this.$store.getters.application.applicationCode;
          getAction("/sys/user/emplistByEntranceCode",param).then(res=>{
            if(res.success){
              this.dataSource = res.result.records;
              this.ipagination.total = res.result.total;
              this.selectedRows = [];
              this.selectedIds=[];

              if(this.selectedDataSouce.length>0){
                let ids = this.selectedDataSouce.map(item => item.id);
                let idsbak = this.dataSouceBak.map(item => item.id);
                res.result.records.forEach(item=>{
                  if (ids.indexOf(item.id) !== -1) {
                    if(idsbak.indexOf(item.id) !== -1){
                      item.disableFlag = '1';
                    }
                    this.selectedRows.push(item);
                    this.selectedIds.push(item.id)
                  }
                })
              }else{
                if(this.dataSouceBak.length>0){
                  let idsbak = this.dataSouceBak.map(item => item.id);
                  res.result.records.forEach(item=>{
                    if (idsbak.indexOf(item.id) !== -1) {
                      item.disableFlag = '1';
                      this.selectedRows.push(item);
                      this.selectedIds.push(item.id)
                    }
                  })
                }
              }
            }
          })
        },
        selectedRemove(record){
          if(this.selectedIds.findIndex(item => item === record.id)!==-1){
            this.selectedIds.splice(this.selectedIds.findIndex(item => item === record.id),1);
          }
          if(this.selectedRows.findIndex(item => item.id === record.id)!==-1){
            this.selectedRows.splice(this.selectedRows.findIndex(item => item.id === record.id),1);
          }
          if(this.selectedDataSouce.findIndex(item => item.id === record.id)!==-1) {
            this.selectedDataSouce.splice(this.selectedDataSouce.findIndex(item => item.id === record.id), 1);
          }
        },
        searchReset(){
          this.queryParam = {}
        },
        close () {
          this.$emit('close');
          this.queryParam = {}
          this.ipagination =  {
            current: 1,
              pageSize: 5,
              showTotal: (total, range) => {
              return range[0] + '-' + range[1] + ' '+this.$store.getters.language['common.total'] + total + this.$store.getters.language['common.strip']
            },
              showQuickJumper: true,
              // showSizeChanger: true,
              total: 0
          }
          this.userVisible = false;
        },
        handleOk () {
          if(!!this.colId){
            let list = [];
            this.selectedDataSouce.forEach(item=>{
              let map = {approverId:item.id,colId:this.colId}
              list.push(map)
            })
            postAction("/hhemp/cmsColApprover/batchAddByCol/"+this.colId,list).then(res=>{
              if(res.success){
                this.$message.success(this.language["operationSuccess"]);
                this.submitCallback();
              }else{
                this.$message.success(this.language["common.errorContext"]);
              }
            })
          }else{
            this.submitCallback();
          }

        },
        submitCallback(){
          this.$emit('ok');
          this.close();
        },
        handleCancel () {
          this.close()
        },
      }
    }
</script>

<style scoped>

</style>